module.exports = __webpack_public_path__ + "img/IMG_0300_L.33452414.webp";